import React from "react";
import { formatParishOptionLabel } from "../utils/parishLabels";

interface GroupedParishNativeOptionsProps {
  parishList?: any[];
  includeNoneOther?: boolean;
}

export default function GroupedParishNativeOptions({
  parishList = [],
  includeNoneOther = false,
}: GroupedParishNativeOptionsProps) {
  const list = Array.isArray(parishList) ? parishList : [];
  return (
    <>
      {includeNoneOther ? (
        <>
          <option value="">NONE / NINGUNA</option>
          <option value="OTHER">OTHER / OTRA</option>
        </>
      ) : null}
      <optgroup label="Select Parish">
        {list
          .filter((p) => p.parishCategoryName?.toUpperCase() !== "OTHER")
          .map((item) => (
            <option key={item.id} value={item.id}>
              {formatParishOptionLabel(item)}
            </option>
          ))}
      </optgroup>
      <optgroup label="OTHER">
        {list
          .filter((p) => p.parishCategoryName?.toUpperCase() === "OTHER")
          .map((item) => (
            <option key={item.id} value={item.id}>
              {formatParishOptionLabel(item, { omitCategory: true })}
            </option>
          ))}
      </optgroup>
    </>
  );
}
